import React from "react";

const TechBaseImage = (props) => {
  const { src } = props;
  return <img {...props} src={src || "/logo.png"} />;
};

export default TechBaseImage;
